// learnPointUserServices.js

import { SYSTEM_ERROR } from "../config/CONSTANTS";
import {
  GET_LD_PARENT_CLIENT,
  GET_LD_COUNTRY_CODE,
  GET_LD_SITE_CODE,
  GET_LD_CLIENT,
  GET_LD_PROGRAM,
  GET_LD_PROJECT,
  GET_LD_ACTIVE_VISITOR,
  GET_LD_FRAMEWORK_VISITOR,
  SAVE_LD_FRAMEWORK_VISITOR,
  DELETE_LD_FRAMEWORK_VISITOR,
  ADD_LD_FRAMEWORK_VISITOR,
  GET_LD_ACTIVE_SEGMENT,
  GET_LD_FRAMEWORK_SEGMENT,
  ADD_LD_FRAMEWORK_SEGMENT,
  SAVE_LD_FRAMEWORK_SEGMENT,
  DELETE_LD_FRAMEWORK_SEGMENT,
  GET_FRAMEWORK_SEARCH_RESULTS,
  FILTER_FRAMEWORKS,
  GET_FRAMEWORK,
  UPDATE_FRAMEWORK,
  GET_CURRICULUM_STATUS,
  GET_CLASS_ROSTER_DETAILS,
  FILTER_CLASS_ROSTER_BY_TRAINER_EMAIL,
  GET_RECENT_ROSTERS_FOR_USER,
  GET_CLASS_ROSTER_DATAGRID_DETAILS,
  GET_CLASS_TRAINEE_MILESTONE_DETAILS,
  GET_MILESTONE_BY_ROSTER_ID,
  GET_MILESTONE_STATUS_BY_ROSTER_ID,
  GET_TRAINEE_STATUS_LIST,
  UPDATE_CURRICULUM_STATUS,
  CREATE_FRAMEWORK,
  GET_ALL_CLASSTYPES,
  GET_FRAMEWORK_MILESTONES,
  SAVE_FRAMEWORK_MILESTONES,
  UPDATE_CLASS_ROSTER_HEADER,
  GET_SEARCH_VALUE,
  GET_CONTENT_SEARCH_VALUE,
  UPDATE_CLASS_TRAINEE_MILESTONE_GRID,
  GET_DTR_LIST_ROSTER_WISE,
  GET_DTR_CLASS_DETAILS,
  GET_DTR_CLASS_DETAILS_PER_ROSTER,
  GET_CLASS_ROSTER_PROJECT_DETAILS,
  GET_CLASS_ROSTER_SITE_DETAILS,
  GET_DTR_LIST_FOR_ROSTER,
  GET_DTR_DATE_DETAILS,
  GET_DTR_TRAININGNOTES,
  SAVE_DTR_DRAFT,
  SEND_DTR_EMAIL,
  PREVIEW_DTR_EMAIL,
  INSERT_DTR_DISTRO,
  UPDATE_DTR_DISTRO,
  GET_ALL_DTR_DISTRO,
  FILTER_CLASS_ROSTER_BY_TRAINEE_EMAIL,
  GET_MERGE_CLASS_TRAINEE_MILESTONE_DETAILS,
  GET_MILESTONE_BY_MERGE_ROSTER_ID,
  UPDATE_MERGE_CLASS_TRAINEE_MILESTONE_GRID,
  BULK_UPDATE_CLASS_TRAINEE_MILESTONE_GRID,
  BULK_UPDATE_MERGE_CLASS_TRAINEE_MILESTONE_GRID,
  UPDATE_MERGE_CLASSROSTER_CURRICULUM_STATUS,
  GET_MERGE_CLASS_ROSTER_DETAILS,
  GET_DTR_ATTENDANCERANGE,
  GET_DTR_ATTENDANCE,
  GET_PORTFOLIO_LIST,
  SAVE_HANDOFF_DRAFT,
  GET_HANDOFF_NOTES,
  SEND_HANDOFF_EMAIL,
  PREVIEW_HANDOFF_EMAIL,
  UPLOAD_DTR_ATTACHMENT,
  GET_DTR_ATTACHMENTS,
  DELETE_DTR_ATTACHMENT,
  SAVE_DTR_TRAINING_NOTES_WITH_ATTACHMENTS,
  SAVE_HANDOFF_REPORT_WITH_ATTACHMENTS,
  GET_DTR_ATTACHMENTS_BY_PARENT_ID,
  DOWNLOAD_ATTACHMENT_IMAGE,
} from "./CONSTANTS";

import axiosInstance from "./axiosInstance";

const BASE_URL = process.env.REACT_APP_BASE_URL_CONFIG;

// Normalizes the API's camelCase attachment DTO fields to the PascalCase names every UI
// consumer expects (DTRAttachmentList.js, TrainingNotes.js, HandOffReport.js).
const normalizeDTRAttachment = (a) => ({
  LP_DTRAttachmentId: a.LP_DTRAttachmentId ?? a.lP_DTRAttachmentId,
  ClassRosterId: a.ClassRosterId ?? a.classRosterId,
  ReportKind: a.ReportKind ?? a.reportKind,
  ReportKey: a.ReportKey ?? a.reportKey,
  AttachmentKind: a.AttachmentKind ?? a.attachmentKind,
  FileName: a.FileName ?? a.fileName,
  FileUrl: a.FileUrl ?? a.fileUrl,
  FileDocLibId: a.FileDocLibId ?? a.fileDocLibId,
  FileSizeBytes: a.FileSizeBytes ?? a.fileSizeBytes,
  CreatedBy: a.CreatedBy ?? a.createdBy,
  CreatedDate: a.CreatedDate ?? a.createdDate,
});

export const checkPermission = async (access) => {
  if (access) {
    const allPermissions = [
      "General_Limited_Group",
      "PII_Group",
      "PII_Group_Low",
      "PII_Group_Med",
      "PII_Group_FULL",
      "Ops_Group",
      "OG_Group",
      "LD_Group",
      "LD_Group_Admin",
      "TA_Group",
      "WFM_Group",
      "CP_Group",
      "ISU_PRV_Access",
      "ASD_Group",
    ];
    return allPermissions.some((permission) => access.includes(permission));
  }
  return false;
};

export const getAllParentClients = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_LD_PARENT_CLIENT())
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getAllCountryCodes = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_LD_COUNTRY_CODE())
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getAllSiteCodes = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_LD_SITE_CODE())
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getclientData = (id) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_LD_CLIENT() + "?parentClientId=" + id)
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in getclientData axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getprojectData = (id) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_LD_PROJECT() + "?parentClientId=" + id)
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in getprojectData axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getprogramData = (id) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_LD_PROGRAM() + "?parentClientId=" + id)
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in getprogramData axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getActiveVisitors = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_LD_ACTIVE_VISITOR(), { validateStatus: false })
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in getActiveVisitors axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getFramworkVisitors = (id) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_LD_FRAMEWORK_VISITOR() + "?frameworkId=" + id, {
          validateStatus: false,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in getFramworkVisitors axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const updateFramworkVisitors = (
  FrameworkVisitorId,
  FrameworkId,
  VisitorId,
  reqVisit,
  modifiedBy,
) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .put(
          BASE_URL +
            SAVE_LD_FRAMEWORK_VISITOR() +
            `?frameworkVisitorId=${FrameworkVisitorId}&frameworkId=${FrameworkId}&visitorId=${VisitorId}&requiredVisits=${reqVisit}&modifiedBy=${modifiedBy}`,
          {},
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in updateFramworkVisitors axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const deleteFramworkVisitor = (FrameworkVisitorId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .delete(
          BASE_URL +
            DELETE_LD_FRAMEWORK_VISITOR() +
            `?frameworkVisitorId=${FrameworkVisitorId}`,
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in deleteFramworkVisitor axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const addFramworkVisitor = (frameworkId, VisitorId, modifiedBy) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(
          BASE_URL +
            ADD_LD_FRAMEWORK_VISITOR() +
            `?frameworkId=${frameworkId}&visitorId=${VisitorId}&createdBy=${modifiedBy}`,
          {},
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in addFramworkVisitor axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getActiveSegments = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_LD_ACTIVE_SEGMENT(), { validateStatus: false })
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in getActiveSegments axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getFramworkSegment = (id) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_LD_FRAMEWORK_SEGMENT() + "?frameworkId=" + id, {
          validateStatus: false,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in getFramworkSegment axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const addFramworkSegment = (
  frameworkId,
  SegmentId,
  DurationDays,
  modifiedBy,
) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(
          BASE_URL +
            ADD_LD_FRAMEWORK_SEGMENT() +
            `?frameworkId=${frameworkId}&segmentId=${SegmentId}&durationDays=${DurationDays}&createdBy=${modifiedBy}`,
          {},
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in addFramworkSegment axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const updateFramworkSegment = (
  frameworkSegmentId,
  frameworkId,
  segmentId,
  durationDays,
  modifiedBy,
) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .put(
          BASE_URL +
            SAVE_LD_FRAMEWORK_SEGMENT() +
            `?frameworkSegmentId=${frameworkSegmentId}&frameworkId=${frameworkId}&segmentId=${segmentId}&durationDays=${durationDays}&modifiedBy=${modifiedBy}`,
          {},
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in updateFramworkSegment axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const deleteFramworkSegment = (frameworkSegmentId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .delete(
          BASE_URL +
            DELETE_LD_FRAMEWORK_SEGMENT() +
            `?frameworkSegmentId=${frameworkSegmentId}`,
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in deleteFramworkSegment axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getFrameworkSearchResults = (payload) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + GET_FRAMEWORK_SEARCH_RESULTS(), payload)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const filterFrameWorks = (payload) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + FILTER_FRAMEWORKS(), payload, {
          validateStatus: false,
        })
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getFramework = (frameworkId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_FRAMEWORK() + `?frameworkId=${frameworkId}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const updateFramework = (payload) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .put(BASE_URL + UPDATE_FRAMEWORK(), payload)
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in updateFramework axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getCurriculumStatus = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_CURRICULUM_STATUS())
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in getCurriculumStatus axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

// In-flight request de-duplication: parent (ClassRoster) and child grid
// (ClassRosterGridV2) both request the same roster's details on mount. Sharing
// a single in-flight promise per rosterId collapses those concurrent duplicate
// network calls into one and prevents duplicate retries while a request (incl.
// a failing one) is still pending. The entry is cleared once settled so later
// legitimate refetches (e.g. after an edit save) still hit the network.
const inFlightClassRosterDetails = new Map();

export const getClassRosterDetails = (rosterId) => {
  const requestKey = String(rosterId);

  if (inFlightClassRosterDetails.has(requestKey)) {
    return inFlightClassRosterDetails.get(requestKey);
  }

  const request = new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          BASE_URL + GET_CLASS_ROSTER_DETAILS() + "?classRosterId=" + rosterId,
          {
            validateStatus: false,
          },
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in getClassRosterDetails axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  }).finally(() => {
    inFlightClassRosterDetails.delete(requestKey);
  });

  inFlightClassRosterDetails.set(requestKey, request);
  return request;
};

// ASTT-7178: reportTypeId (Hand Off) and dtrDate (Training Notes) both
// optional -- when either is provided, the response's roster rows also
// carry the corresponding status field (HandOffReportStatus or
// DTRStatus) for coloring in ClassDetails.js, without a separate call.
export const getClassRosterIds = (TrainerEmail, reportTypeId, dtrDate) => {
  return new Promise((resolve, reject) => {
    try {
      const reportTypeParam =
        reportTypeId !== undefined && reportTypeId !== null
          ? `&reportTypeId=${reportTypeId}`
          : "";
      const dtrDateParam =
        dtrDate !== undefined && dtrDate !== null && dtrDate !== ""
          ? `&dtrDate=${dtrDate}`
          : "";
      axiosInstance
        .get(
          BASE_URL +
            FILTER_CLASS_ROSTER_BY_TRAINER_EMAIL() +
            "?trainerEmail=" +
            TrainerEmail +
            reportTypeParam +
            dtrDateParam,
        )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

// ASTT-7319: "Recent Roster(s)" grouping, per stakeholder-demo feedback --
// modifiedBy is a display name (e.g. "Hitesh Kavar", matching
// localStorage's own "User" entry), not an email -- this endpoint's
// underlying query filters LP_DTRTrainingNotes/LP_HandOffReport's own
// ModifiedBy column, which stores names, not FILTER_CLASS_ROSTER_BY_
// TRAINER_EMAIL's email-based filtering above.
export const getRecentRostersForUser = (modifiedBy, topN = 20) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          BASE_URL +
            GET_RECENT_ROSTERS_FOR_USER() +
            `?modifiedBy=${encodeURIComponent(modifiedBy)}&topN=${topN}`,
        )
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          // ASTT-7319 follow-up: logged explicitly -- this call's own
          // caller (ClassDetails.js's fetchRosterData) only checks
          // response?.statusCode === 200, meaning any actual HTTP/network
          // failure here (404 if the endpoint/procedure doesn't exist,
          // 500 if the procedure itself errors, etc.) was previously
          // resolving silently with no visible trace anywhere -- exactly
          // matching a reported "Recent Roster(s) group doesn't appear at
          // all, even after restarting both projects" symptom, which
          // pointed at a silently-swallowed failure rather than a caching
          // issue a restart could fix.
          console.error("Failed to fetch recent rosters:", err);
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getClassRostersByTraineeEmail = (TraineeEmail) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          BASE_URL +
            FILTER_CLASS_ROSTER_BY_TRAINEE_EMAIL() +
            "?traineeEmail=" +
            TraineeEmail,
        )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getClassRosterDataGridDetails = (rosterId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          BASE_URL +
            GET_CLASS_ROSTER_DATAGRID_DETAILS() +
            "?classRosterId=" +
            rosterId,
          { validateStatus: false },
        )
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          console.log("Error in getClassRosterDataGridDetails axios!");
          reject("Error in getClassRosterDataGridDetails axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getClassTraineeMilestoneDetails = (rosterId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          BASE_URL +
            GET_CLASS_TRAINEE_MILESTONE_DETAILS() +
            "?ClassRosterId=" +
            rosterId,
          { validateStatus: false },
        )
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          console.log("Error in getClassTraineeMilestoneDetails axios!");
          reject("Error in getClassTraineeMilestoneDetails axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getMilestoneByRosterId = (rosterId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          BASE_URL +
            GET_MILESTONE_BY_ROSTER_ID() +
            "?ClassRosterId=" +
            rosterId,
          { validateStatus: false },
        )
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          console.log("Error in getMilestoneByRosterId axios!");
          reject("Error in getMilestoneByRosterId axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getMilestoneStatusByRosterId = (rosterId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          BASE_URL +
            GET_MILESTONE_STATUS_BY_ROSTER_ID() +
            "?ClassRosterId=" +
            rosterId,
          { validateStatus: false },
        )
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          console.log("Error in getMilestoneStatusByRosterId axios!");
          reject("Error in getMilestoneStatusByRosterId axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getTraineeStatusList = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_TRAINEE_STATUS_LIST())
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in getTraineeStatusList axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const updateClassTraineeMilestoneGridDetails = (
  ClassRosterId,
  ClassTraineeId,
  FieldToUpdate,
  ValueToUpdate,
) => {
  return new Promise((resolve, reject) => {
    try {
      const body = {
        classRosterId: ClassRosterId,
        classTraineeId: ClassTraineeId,
        fieldToUpdate: FieldToUpdate,
        valueToUpdate: ValueToUpdate,
      };
      axiosInstance
        .put(BASE_URL + UPDATE_CLASS_TRAINEE_MILESTONE_GRID(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in updateClassTraineeMilestoneGridDetails axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const updateClassRosterCurriculumStatus = (
  rosterId,
  CurriculumStatusId,
) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .put(
          BASE_URL +
            UPDATE_CURRICULUM_STATUS() +
            `?ClassRosterId=${rosterId}&CurriculumStatusId=${CurriculumStatusId}`,
          {},
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in updateClassRosterCurriculumStatus axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const createFramework = (payload) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + CREATE_FRAMEWORK(), payload, { validateStatus: false })
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getAllClassTypes = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_ALL_CLASSTYPES())
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in getAllClassTypes axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getFrameworkMilestones = (frameworkId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          BASE_URL + GET_FRAMEWORK_MILESTONES() + `?frameworkId=${frameworkId}`,
          {
            validateStatus: false,
          },
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in getFrameworkMilestones axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const saveFrameworkMilestones = (payload) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + SAVE_FRAMEWORK_MILESTONES(), payload, {
          validateStatus: false,
        })
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const updateClassRosterHeader = (id, User, payload) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + UPDATE_CLASS_ROSTER_HEADER(), payload, {
          params: { classRosterId: id, modifiedBy: User },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in updateClassRosterHeader axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getSearchValue = (value) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_SEARCH_VALUE(), { params: { name: value } })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getSearchPopoverContent = (value) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_CONTENT_SEARCH_VALUE(), {
          params: { classTraineeId: value },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getDTRListClassRosterIdWise = (rosterId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_DTR_LIST_ROSTER_WISE(), {
          params: { classRosterId: rosterId },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getDTRClassDetails = (rosterId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_DTR_CLASS_DETAILS() + `/?ClassRosterId=${rosterId}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

// ASTT-7319: new, additive -- returns an array with one entry per selected
// roster (not one combined/concatenated object the way getDTRClassDetails
// above does), for a new UI table view. See the API controller's own
// comment for why this exists alongside getDTRClassDetails rather than
// replacing it.
export const getDTRClassDetailsPerRoster = (rosterId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          BASE_URL +
            GET_DTR_CLASS_DETAILS_PER_ROSTER() +
            `/?ClassRosterId=${rosterId}`,
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

// ASTT-7319: two new drill-down calls ("View Projects"/"View Site"),
// called per-roster on demand rather than joined into the per-roster
// table fetch above -- see the API controller's own comment.
export const getClassRosterProjectDetails = (classRosterId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          BASE_URL +
            GET_CLASS_ROSTER_PROJECT_DETAILS() +
            `/?ClassRosterId=${classRosterId}`,
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getClassRosterSiteDetails = (classRosterId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          BASE_URL +
            GET_CLASS_ROSTER_SITE_DETAILS() +
            `/?ClassRosterId=${classRosterId}`,
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

// ASTT-7319: "View DTRs" drill-down (item 7).
export const getDTRListForRoster = (classRosterId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          BASE_URL +
            GET_DTR_LIST_FOR_ROSTER() +
            `/?ClassRosterId=${classRosterId}`,
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getDTRDateDetails = (rosterID) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_DTR_DATE_DETAILS() + `/?ClassRosterID=${rosterID}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getDTRTrainingNotes = (rosterId, dtrDate) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          BASE_URL +
            GET_DTR_TRAININGNOTES() +
            `/?ClassRosterId=${rosterId}&DTRDate=${dtrDate}`,
          { validateStatus: false },
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const saveDTRDraft = (payload) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + SAVE_DTR_DRAFT(), payload, { validateStatus: false })
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const sendDTREmail = (payload) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + SEND_DTR_EMAIL(), payload, { validateStatus: false })
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

// ASTT-7319: read-only preview, per direct stakeholder-demo feedback --
// returns the same rendered {EmailSubject, MessageBody} sendDTREmail
// would queue, without actually queuing anything.
export const previewDtrEmail = (dtrId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + PREVIEW_DTR_EMAIL() + `/?dtrId=${dtrId}`)
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const InsertDTRDistro = (DistroName, DistroEmail, CreatedBy) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(
          BASE_URL +
            INSERT_DTR_DISTRO() +
            `?DistroName=${DistroName}&DistroEmail=${DistroEmail}&CreatedBy=${CreatedBy}`,
          {},
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in InsertDTRDistro axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const UpdateDTRDistro = (payload) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .put(BASE_URL + UPDATE_DTR_DISTRO(), payload)
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in UpdateDTRDistro axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getAllDTRDistro = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_ALL_DTR_DISTRO())
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in getAllDTRDistro axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getMergeClassTraineeMilestoneDetails = (rosterId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          BASE_URL +
            GET_MERGE_CLASS_TRAINEE_MILESTONE_DETAILS() +
            "?ClassRosterId=" +
            rosterId,
          {
            // timeOut is not a valid axios config key — kept as a custom header
            // to preserve original intent without breaking anything
            headers: { timeOut: 180000 },
            validateStatus: false,
          },
        )
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          console.log("Error in getMergeClassTraineeMilestoneDetails axios!");
          reject("Error in getMergeClassTraineeMilestoneDetails axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getMilestoneByMergeRosterId = (rosterId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          BASE_URL +
            GET_MILESTONE_BY_MERGE_ROSTER_ID() +
            "?ClassRosterId=" +
            rosterId,
          { validateStatus: false },
        )
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          console.log("Error in getMilestoneByMergeRosterId axios!");
          reject("Error in getMilestoneByMergeRosterId axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const updateMergeClassTraineeMilestoneGridDetails = (
  ClassRosterId,
  ClassTraineeId,
  FieldToUpdate,
  ValueToUpdate,
) => {
  return new Promise((resolve, reject) => {
    try {
      const body = {
        classRosterId: ClassRosterId,
        classTraineeId: ClassTraineeId,
        fieldToUpdate: FieldToUpdate,
        valueToUpdate: ValueToUpdate,
      };
      axiosInstance
        .put(BASE_URL + UPDATE_MERGE_CLASS_TRAINEE_MILESTONE_GRID(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in updateMergeClassTraineeMilestoneGridDetails axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

/**
 * Bulk update for ClassRoster (non-merge).
 * Sends all selected-row × field updates in a single PUT request.
 *
 * @param {number}   classRosterId  - roster being edited
 * @param {Array}    updates        - [{ classTraineeId, fieldToUpdate, valueToUpdate }]
 */
export const bulkUpdateClassTraineeMilestoneGridDetails = (
  classRosterId,
  updates,
) => {
  return new Promise((resolve, reject) => {
    try {
      const body = { classRosterId, updates };
      axiosInstance
        .put(BASE_URL + BULK_UPDATE_CLASS_TRAINEE_MILESTONE_GRID(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in bulkUpdateClassTraineeMilestoneGridDetails axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

/**
 * Bulk update for Merge ClassRoster.
 *
 * @param {string}   classRosterId  - comma-separated roster ID string
 * @param {Array}    updates        - [{ classTraineeId, fieldToUpdate, valueToUpdate }]
 */
export const bulkUpdateMergeClassTraineeMilestoneGridDetails = (
  classRosterId,
  updates,
) => {
  return new Promise((resolve, reject) => {
    try {
      const body = { classRosterId, updates };
      axiosInstance
        .put(BASE_URL + BULK_UPDATE_MERGE_CLASS_TRAINEE_MILESTONE_GRID(), body)
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject(
            "Error in bulkUpdateMergeClassTraineeMilestoneGridDetails axios!",
          );
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const updateMergeClassRosterCurriculumStatus = (
  rosterId,
  CurriculumStatusId,
) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .put(
          BASE_URL +
            UPDATE_MERGE_CLASSROSTER_CURRICULUM_STATUS() +
            `?ClassRosterId=${rosterId}&CurriculumStatusId=${CurriculumStatusId}`,
          {},
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in updateMergeClassRosterCurriculumStatus axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getMergeClassRosterDetails = (rosterId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          BASE_URL +
            GET_MERGE_CLASS_ROSTER_DETAILS() +
            "?classRosterId=" +
            rosterId,
          { validateStatus: false },
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch(() => {
          reject("Error in getMergeClassRosterDetails axios!");
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getDtrAttendanceRange = (rosterId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          BASE_URL + GET_DTR_ATTENDANCERANGE() + "?classRosterId=" + rosterId,
          {
            validateStatus: false,
          },
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getDtrAttendance = (oracleIDs, startDate, endDate) => {
  return new Promise((resolve, reject) => {
    try {
      const url =
        BASE_URL +
        GET_DTR_ATTENDANCE() +
        "?oracleIds=" +
        oracleIDs +
        "&startDate=" +
        startDate +
        "&endDate=" +
        endDate;
      axiosInstance
        .get(url, { timeout: 180000, validateStatus: false })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getPortfolioList = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_PORTFOLIO_LIST(), {
          validateStatus: false,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const saveHandOffDraft = (payload) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + SAVE_HANDOFF_DRAFT(), payload, {
          validateStatus: false,
        })
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getHandOffNotes = (rosterId, reportType) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          BASE_URL +
            GET_HANDOFF_NOTES() +
            `/?ClassRosterId=${rosterId}&ReportTypeId=${reportType}`,
          { validateStatus: false },
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const sendHandOffEmail = (payload) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + SEND_HANDOFF_EMAIL(), payload, {
          validateStatus: false,
        })
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

// ASTT-7319: Hand-Off Report's own read-only preview counterpart -- see
// previewDtrEmail's identical comment.
export const previewHandOffEmail = (handOffReportId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(
          BASE_URL + PREVIEW_HANDOFF_EMAIL() + `/?handOffReportId=${handOffReportId}`,
        )
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const uploadDTRAttachment = (file, meta) => {
  return new Promise((resolve, reject) => {
    try {
      const formData = new FormData();
      formData.append("File", file);
      formData.append("ClassRosterId", meta.classRosterId ?? "");
      formData.append("ClassRequestId", meta.classRequestId ?? "");
      formData.append("ReportKind", meta.reportKind ?? "");
      formData.append("ReportKey", meta.reportKey ?? "");
      formData.append("AttachmentKind", meta.attachmentKind ?? "");
      formData.append("CreatedBy", meta.createdBy ?? "");

      axiosInstance
        .post(BASE_URL + UPLOAD_DTR_ATTACHMENT(), formData, {
          headers: { "Content-Type": undefined },
          validateStatus: false,
        })
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getDTRAttachments = (classRosterId, reportKind, reportKey) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_DTR_ATTACHMENTS(), {
          params: { classRosterId, reportKind, reportKey },
          validateStatus: false,
        })
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const deleteDTRAttachment = (attachmentId, fileDocLibId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .delete(BASE_URL + DELETE_DTR_ATTACHMENT(), {
          params: { attachmentId, fileDocLibId },
          validateStatus: false,
        })
        .then((res) => {
          resolve(res?.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const saveDTRTrainingNotesWithAttachments = (payload, pendingAttachments) => {
  return new Promise((resolve, reject) => {
    try {
      const attachments = pendingAttachments || [];
      const formData = new FormData();
      formData.append("ClassRosterId", payload.classRosterId ?? "");
      formData.append("ClassRequestId", payload.classRequestId ?? "");
      formData.append("DTRDate", payload.dtrDate ?? "");
      formData.append("Successes", payload.successes ?? "");
      formData.append("Challenges", payload.challenges ?? "");
      formData.append("TopicsCovered", payload.topicsCovered ?? "");
      formData.append("ClassRiskCategory", payload.classRiskCategory ?? "");
      formData.append("ClassRiskNotes", payload.classRiskNotes ?? "");
      formData.append("LP_DTRDistroId", payload.lP_DTRDistroId ?? 0);
      formData.append("EmailDistro", payload.emailDistro ?? "");
      formData.append("DTRStatus", payload.dtrStatus ?? "");
      formData.append("ModifiedBy", payload.modifiedBy ?? "");
      formData.append("AttachmentIdsToDelete", payload.attachmentIdsToDelete ?? "");
      formData.append(
        "PendingFilesMetadataJson",
        JSON.stringify(
          attachments.map((a) => ({
            kind: a.kind,
            placeholderToken: a.placeholderToken,
            fieldName: a.fieldName,
          })),
        ),
      );
      attachments.forEach((a) => formData.append("Files", a.file));

      axiosInstance
        .post(
          BASE_URL + SAVE_DTR_TRAINING_NOTES_WITH_ATTACHMENTS(),
          formData,
          { headers: { "Content-Type": undefined }, validateStatus: false },
        )
        .then((res) => {
          const body = res?.data;
          // Normalize attachment casing — saveAsDraft sets existingAttachments from this.
          if (body?.data && Array.isArray(body.data.attachments)) {
            resolve({
              ...body,
              data: {
                ...body.data,
                attachments: body.data.attachments.map(normalizeDTRAttachment),
              },
            });
          } else {
            resolve(body);
          }
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

// Hand-Off Report counterpart to saveDTRTrainingNotesWithAttachments - same shape/reasoning.
export const saveHandOffReportWithAttachments = (payload, pendingAttachments) => {
  return new Promise((resolve, reject) => {
    try {
      const attachments = pendingAttachments || [];
      const formData = new FormData();
      formData.append("ClassRosterId", payload.classRosterId ?? "");
      formData.append("ClassRequestId", payload.classRequestId ?? "");
      formData.append("ReportTypeId", payload.reportTypeId ?? "");
      formData.append("FinalEquipmentStatus", payload.finalEquipmentStatus ?? "");
      formData.append("FinalClientIdStatus", payload.finalClientIdStatus ?? "");
      formData.append("FinalTTECIdStatus", payload.finalTTECIdStatus ?? "");
      formData.append("FinalTTECFundamentalsStatus", payload.finalTTECFundamentalsStatus ?? "");
      formData.append("FinalCurriculumStatus", payload.finalCurriculumStatus ?? "");
      formData.append("Successes", payload.successes ?? "");
      formData.append("Challenges", payload.challenges ?? "");
      formData.append("ReadinessNotes", payload.readinessNotes ?? "");
      formData.append("LP_DTRDistroId", payload.lP_DTRDistroId ?? 0);
      formData.append("EmailDistro", payload.emailDistro ?? "");
      formData.append("HandOffReportStatus", payload.handOffReportStatus ?? "");
      formData.append("ModifiedBy", payload.modifiedBy ?? "");
      formData.append("AttachmentIdsToDelete", payload.attachmentIdsToDelete ?? "");
      formData.append(
        "PendingFilesMetadataJson",
        JSON.stringify(
          attachments.map((a) => ({
            kind: a.kind,
            placeholderToken: a.placeholderToken,
            fieldName: a.fieldName,
          })),
        ),
      );
      attachments.forEach((a) => formData.append("Files", a.file));

      axiosInstance
        .post(
          BASE_URL + SAVE_HANDOFF_REPORT_WITH_ATTACHMENTS(),
          formData,
          { headers: { "Content-Type": undefined }, validateStatus: false },
        )
        .then((res) => {
          const body = res?.data;
          // Normalize attachment casing — see saveDTRTrainingNotesWithAttachments above.
          if (body?.data && Array.isArray(body.data.attachments)) {
            resolve({
              ...body,
              data: {
                ...body.data,
                attachments: body.data.attachments.map(normalizeDTRAttachment),
              },
            });
          } else {
            resolve(body);
          }
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getDTRAttachmentsByParentId = (trainingNotesId, handOffReportId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_DTR_ATTACHMENTS_BY_PARENT_ID(), {
          params: { trainingNotesId, handOffReportId },
          validateStatus: false,
        })
        .then((res) => {
          const body = res?.data;
          // Normalize attachment casing before it reaches any consumer.
          if (body && Array.isArray(body.data)) {
            resolve({ ...body, data: body.data.map(normalizeDTRAttachment) });
          } else {
            resolve(body);
          }
        })
        .catch((err) => {
          resolve(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

// ASTT-7319 follow-up: in-app inline-image display fix. A plain
// <img src="https://...sharepoint.com/..."> can never authenticate --
// SharePoint uploads use certificate-based, app-only auth held server-
// side only, and axiosInstance's own bearer token (attached by its
// request interceptor) can't be attached to a browser-native image load
// either way. So this fetches the bytes through axiosInstance (which
// does carry that token) as a blob, then hands back a local blob: URL
// the caller can actually put in an <img src> -- same shape as how
// pending, not-yet-saved images already get a live blob: URL via
// URL.createObjectURL in RichTextEditorField.js, just for an
// already-saved image instead of a pending one.
export const downloadAttachmentImageAsBlobUrl = (fileDocLibId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + DOWNLOAD_ATTACHMENT_IMAGE(), {
          params: { fileDocLibId },
          responseType: "blob",
        })
        .then((res) => {
          resolve(URL.createObjectURL(res.data));
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};
